import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { provideChildTranslateService, TranslateService } from '@ngx-translate/core';
import { TranslationFeature } from '@core/translation/models/translation-feature.enum';
import { translationRootUrl } from '@core/translation/models/translation-root-url';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationFacade } from '@core/translation/facades/translation.facade';

export const provideFeatureTranslations = (translationFeature: TranslationFeature): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideChildTranslateService({
      loader: provideTranslateHttpLoader({ prefix: `${translationRootUrl}${translationFeature}/`, useHttpBackend: true }),
    }),
    /* Due to a bug in ngx-translate library we need to call .use() method for the lazy loaded translations to be loaded at all.
     * https://github.com/ngx-translate/core/issues/1302
     * This is something that should be monitored. Potentially will be fixed in v18 of ngx-translate package. */
    provideEnvironmentInitializer((): void => {
      inject(TranslationFacade).addTranslateService(inject(TranslateService));
    }),
  ]);
